module.exports = __webpack_public_path__ + "img/main_gamebg.1a58faf6.png";